import {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {getFirmantes} from '../../../Api'
import {formatearFechaHora} from '../../../Utils'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const DocumentView = () => {
  const {token} = useParams()
  const [loading, setLoading] = useState(false)
  const [firmantes, setFirmantes] = useState([])
  const linkApi = process.env.REACT_APP_API_URL

  const fetchFirmantes = async () => {
    setLoading(true)
    try {
      const response: any = await getFirmantes(token)
      if (response.status) {
        setFirmantes(response.data.firmantes)
      }
    } catch (err) {
      console.error('Error fetching firmantes:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchFirmantes()
  }, [])

  return (
    <div className='h-100 p-20'>
      <div className='row m-0 mb-8'>
        <div className='col-sm-12 text-center h-50px'>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/logo_default.png')}
            className='h-50px app-sidebar-logo-default theme-light-show'
          />
        </div>
      </div>
      <div className='row m-0' style={{ height: 'calc(100% - 70px)' }}>
        <div className='col-lg-7 mb-lg-0 mb-10 h-lg-auto h-50'>
          <iframe
            src={`${linkApi}/documento/${token}/ver`}
            width='100%'
            height='100%'
            title='Document Viewer'
          >
            Este navegador no soporta iframes.
          </iframe>
        </div>
        <div className='col-lg-5'>
          <div className='card p-4 h-100'>
            <div className='card-header border-0'>
              <div className='card-title'>
                <h3 className='fw-bold m-0'>Firmantes</h3>
              </div>
            </div>
            <div className='card-body'>
              {loading ? (
                <div className='text-center py-10'>
                  <div className='spinner-border text-primary'></div>
                </div>
              ) : (
                <div>
                  {firmantes.length > 0 ? (
                    <div>
                      {firmantes.map((firmante: any, index: number) => (
                        <div key={index} className='mb-8'>
                          <div className='fw-bold fs-6 mb-2'>{firmante.nombre_completo}</div>
                          <div className='d-flex'>
                            <div style={{width: 100}}>RUT:</div> {firmante.rut}
                          </div>
                          <hr />
                          <div className='d-flex'>
                            <div style={{width: 100}}>Fecha Firma:</div>{' '}
                            {formatearFechaHora(firmante.fecha_firma)}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className='alert alert-info'>
                      No hay firmantes disponibles para este documento.
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DocumentView
